import React, { useEffect, useState } from 'react';
import Loading from '../../../utils/Loading';
import { getKategorije, getPodkategorijeByKategorijaId, updateListePodkategorija } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable } from 'react-beautiful-dnd';
import { Draggable } from 'react-beautiful-dnd';
import { FaEdit } from 'react-icons/fa';
import AddPodkategorijaModal from './AddPodkategorijaModal';

function Podkategorije() {
    const [loading, setLoading] = useState(false);
    const [kategorije, setKategorije] = useState<any>([]);
    const [selectedKategorija, setSelectedKategorija] = useState<any>(null);
    const [selectedPodkategorija, setSelectedPodkategorija] = useState<any>(null);
    const [addPodkategorijaModalOpen, setAddPodkategorijaModalOpen] = useState(false);
    const [podkategorije, setPodkategorije] = useState<any>([]);

    useEffect(() => {
        loadKategorije();
    }, []);

    const loadKategorije = async () => {
        const resp = await getKategorije();
        if (resp.status === 200) {
            setKategorije(resp.data);
        }
    };

    const closeAddPodkategorijaModal = () => {
        setSelectedPodkategorija(null);
        setAddPodkategorijaModalOpen(false);
    };
    const openAddPodkategorijaModal = (item: any) => {
        setSelectedPodkategorija(item);
        setAddPodkategorijaModalOpen(true);
    };
    const fetchPodkategorije = async (item: any) => {
        setSelectedKategorija(item);
        const resp = await getPodkategorijeByKategorijaId(item?.id);
        if (resp.status === 200) {
            setPodkategorije(resp.data);
        }
    };

    const updateRedosledPodkategorija = async (lista: any) => {
        setLoading(true);
        const resp = await updateListePodkategorija(lista);
        if (resp.status == 201) {
            notif('Uspešno ste promenili raspored podkategorija u listi.');
            setPodkategorije(resp.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const handleDrop = (droppedItem: any) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...podkategorije];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        let newReorderList = updatedList.map((item, index) => {
            return { ...item, redosled: index + 1 };
        });
        // Update State
        // setPodkategorije(newReorderList);
        updateRedosledPodkategorija(newReorderList);
    };
    return (
        <div className="p-5 h-full">
            <div className="grid grid-cols-3 gap-5 h-full ">
                <div className="h-full overflow-auto ">
                    <div className="flex flex-row items-center justify-between h-12">
                        <label className="text-[16px] leading-5 text-black font-semibold  ">
                            Lista postojecih kategorija <span>(ukupno {kategorije.length})</span>{' '}
                        </label>
                    </div>
                    {kategorije
                        .sort((a: any, b: any) => a.redosled - b.redosled)
                        .map((item: any, index: number) => {
                            return (
                                <div
                                    className={` border border-black200 rounded-[4px] px-6 py-[5px] mt-1 flex flex-row items-center justify-between cursor-pointer ${
                                        item.id === selectedKategorija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                    }`}
                                    key={index}
                                    onClick={() => fetchPodkategorije(item)}
                                >
                                    <div>
                                        <p className="text-[14px] leading-[18px]">
                                            Naziv: <span className="font-bold">{item.naziv}</span>
                                        </p>
                                        <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                        <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                            Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                {!!selectedKategorija && (
                    <div className="h-full col-span-2 overflow-auto ">
                        <div className="flex flex-row items-center justify-between">
                            <label className="text-[16px] leading-5 text-black font-semibold  ">
                                Lista postojecih potkategorija <span>(ukupno {podkategorije.length})</span>{' '}
                            </label>
                            <button
                                className={`px-3 h-[48px] flex items-center justify-center bg-white border border-black rounded-[4px] text-[16px] leading-5 text-black font-semibold`}
                                onClick={(e) => openAddPodkategorijaModal(null)}
                            >
                                <p>Dodaj novu potkategoriju</p>
                            </button>
                        </div>
                        <DragDropContext onDragEnd={handleDrop}>
                            <Droppable droppableId="list-container">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {podkategorije
                                            .sort((a: any, b: any) => a.redosled - b.redosled)
                                            .map((item: any, index: number) => {
                                                return (
                                                    <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                        {(provided) => (
                                                            <div
                                                                className="bg-white border border-black200 rounded-[4px] px-6 py-[5px] mt-1 flex flex-row items-center justify-between"
                                                                key={index}
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <div>
                                                                    <p className="text-[14px] leading-[18px]">
                                                                        Naziv: <span className="font-bold">{item.naziv}</span>
                                                                    </p>
                                                                    <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                                                    <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                                                        Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                                    </p>
                                                                </div>
                                                                <div className=" cursor-pointer p-2 " onClick={() => openAddPodkategorijaModal(item)}>
                                                                    <FaEdit style={{ width: 20, height: 20 }} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                );
                                            })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                )}
            </div>
            <AddPodkategorijaModal
                modalIsOpen={addPodkategorijaModalOpen}
                closeModal={closeAddPodkategorijaModal}
                kategorija={selectedKategorija}
                podkategorija={selectedPodkategorija}
                reloadPodkategorije={fetchPodkategorije}
            />
        </div>
    );
}

export default Podkategorije;
